<template>
    <div id="chengguan">
        <slider :platInfo = "platInfo"></slider>
    </div>
</template>

<script>
    import slider from '../../components/slider.vue'
    export default {
        name: "chengguan",
        components:{slider},
        data() {
            return {
                swiper: null,
                platInfo:chengguanInfo,
            }
        },
        methods: {},
        mounted() {

        }
    }
</script>

<style lang="css" scoped>
    #chengguan{
        width: 100%;
        height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: row;
        background: linear-gradient(to right,#C1F2F9,#fff,#C1F2F9);;
    }
</style>



// WEBPACK FOOTER //
// src/views/chengguan/chengguan.vue